// base
import React from 'react';

export * from './company';
export * from './dashboard';
export * from './environment';
export * from './notice';
export * from './passport';
export * from './pjt';
export * from './sign';
export * from './system';
export * from './tbm';
export * from './user';
export * from './ptw';

export const LazyHomePage = React.lazy(() => import('./Homepage'));
